<template>
  <el-dialog  :close-on-click-modal="false"  append-to-body v-model="visible" modal-class="is--form" :title="$t(`registration.payment.coupon`)" width="500px" align-center>
    <el-form ref="formRefs" :model="form" label-position="top">
      <el-form-item>
        <!-- <template #label>{{ $t(`registration.payment.coupon-tips`) }}</template> -->
        <el-radio-group v-model="form.hasCoupon">
          <el-radio label="N">{{ $t(`registration.payment.coupon-no`) }}</el-radio>
          <el-radio label="Y">{{ $t(`registration.payment.coupon-yes`) }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" v-if="form.hasCoupon === 'Y'" style="margin-bottom: 0">
        <el-input v-model="form.Coupon" :placeholder="$t(`registration.payment.coupon`)"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <!-- <el-button @click="handleClose">{{ $t(`registration.payment.coupon-use-cancel`) }}</el-button> -->
      <el-button @click="handleVerify" type="primary" v-if="(form.hasCoupon === 'Y' && form.Coupon)">{{ $t(`registration.payment.coupon-use-confirm`) }}</el-button>
      <el-button @click="handleClose" type="primary" v-else>{{ $t(`registration.payment.coupon-use-confirm`) }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { handleError, onMounted, ref, defineExpose } from 'vue'
  import { discount } from '@/api/registration'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import { useI18n } from 'vue-i18n'
  const { t, te } = useI18n()
  const visible = ref(false)
  const emit = defineEmits(['close'])
  const formRefs = ref(null)

  //
  const form = ref({
    rows: [],
    hasCoupon: 'N',
    Coupon: '',
  })

  const handleVerify = async () => {
    formRefs.value.validate(async (valid) => {
      if (!valid) {
        return
      }
      try {
        console.log(form.value)
        const { ret } = await discount(form.value.rows, { coupon: form.value.Coupon })
        ElMessage({ message: t(`registration.payment.coupon-use-ok`), type: 'success' })
        handleClose()
      } catch {
        //ElMessage({ message: t(`registration.payment.coupon-use-fail`), type: 'error' })
      }
    })
  }
  const handleClose = () => {
    emit('close', { rows: form.value.rows })
    visible.value = false
  }

  defineExpose({
    show: (rows) => {
      form.value = {
        rows: rows,
        hasCoupon: 'N',
        Coupon: '',
      }
      visible.value = true
    },
  })
</script>

<style lang="scss" scoped>
  .el-radio-group {
    .el-radio {
      width: 100%;
    }
  }
</style>
